<div [ngClass]="_containerClass">
  <button
    (click)="onClick.emit()"
    [disabled]="isDisabled"
    [ngClass]="_buttonClasses"
    mat-button
  >
    {{ _displayText }}
  </button>
</div>
